import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './forbidden-error.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublisherForbiddenErrorComponent implements OnInit {
    constructor(private _router: Router) { }

    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/forbidden-error/forbidden-error.component.ts